import { render, staticRenderFns } from "./WhyXray.vue?vue&type=template&id=12cf81d1&"
import script from "./WhyXray.vue?vue&type=script&lang=js&"
export * from "./WhyXray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports